module.exports = __webpack_public_path__ + "img/settings_1920.24e3c0cb.webp";